import {Component, EventEmitter, Input, Output, ViewContainerRef} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs/Observable';
import * as _ from 'underscore';
import {Configuration, HttpClientCustom} from '../../shared';
import {SharedData} from '../../shared/sharedData';
import {ToasterComponent} from '../../toasterComponent/toasterComponent';

@Component({
    selector: 'AddOrganization',
    templateUrl: 'addOrganization.html'
})
export class AddOrganizationComponent {

    @Input('parentOrg')
    public parentOrg: any;
    @Output()
    public addOrgEvent = new EventEmitter();
    public _baseUrl: any;
    public type: any = 'ADD';
    public data: any;
    @Output('cancelEvent')
    public cancelEvent: any = new EventEmitter();
    public orgTypeModel: any;
    public oldValue = null;
    public disableButton: any = false;
    public warning: string = "No Org";
    public primarySupervisorModel: string = ''
    public primarySupervisor: string = '';
    public hrSpocModel: string = '';
    public ccAdmin: string = '';
    public ccManager: string = '';
    public leaveAdministrator: string = '';
    public orgCat: string = '';


    public orgData = {
        id: null,
        level: null,
        orgName: null,
        orgUnitCode: null,
        houEmployeeId: null,
        hrSpocId: null,
        orgType: null,
        parentId: null,
        description: null,
        mission: null,
        vision: null,
        status: null,
        noParent: null,
        ccAdminId: null,
        ccManagerId: null,
        leaveAdministratorId: null
    };

    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public _global: Configuration,
        public http: HttpClientCustom,
        public _sanitizer: DomSanitizer,
        public builder: FormBuilder,
        public router: Router,
        public share: SharedData,
        public _toaster: ToasterComponent,
        public translate: TranslateService,
        vcr: ViewContainerRef) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        let data: any = this.share.getData();
        this.data = {};
    }

    public getOrgTree() {
        try {
            let self = this;
            let url = self._baseUrl + 'v1/webAdmin/orgUnit/';
            self.http.get(url).subscribe((result) => {
                self.orgData = result.data;
            });
        } catch (e) {
            console.log('Org Tree error catch', e);
        }
    }

    public autoCompleteOrgCat = (data: any): SafeHtml => {
        let html = `<span>${data.code}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }


    // Formatter
    public orgTypeFormatter(data: any): string {
        return `${data.orgUnitTypeName}`;
    }

    public getIdsWithPayload(keyword) {
        let payload = {
            searchString: null,
            excludeEmpIds: []
        };
        payload.searchString = keyword;
        let everythingButTheNulls = _.compact(payload.excludeEmpIds);
        payload.excludeEmpIds = [];
        payload.excludeEmpIds = everythingButTheNulls;
        return payload;
    }

    public autoCompleteListFormatter = (data: any): SafeHtml => {
        let html = `<span>${data.displayName}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    // ObservableSource
    // to get list of supervisor based on keyword
    public primarySupervisorObservableSource(keyword: any) {
        try {
            if (keyword) {
                let url = this._baseUrl + 'v1/webAdmin/employee/supervisorSearch';
                if (keyword.trim()) {
                    let payload: any = this.getIdsWithPayload(keyword);
                    return this.http.post(url, payload)
                        .map((res) => {
                            return res;
                        });
                } else {
                    return Observable.of([]);
                }
            } else {
                return Observable.of([]);
            }
        } catch (e) {
            console.log(e);
            return Observable.of([]);
        }
    }

    public hrrObservableSource(keyword: any) {
        try {
            if (keyword) {
                let url = this._baseUrl + 'v1/webAdmin/employee/supervisorSearch';
                if (keyword.trim()) {
                    let payload: any = this.getIdsWithPayload(keyword);
                    return this.http.post(url, payload)
                        .map((res) => {
                            return res;
                        });
                } else {
                    return Observable.of([]);
                }
            } else {
                return Observable.of([]);
            }
        } catch (e) {
            return Observable.of([]);
        }
    }

    // To get list of Organization based on keyword
    public orgTypeObservableSource = (keyword: any): Observable<any[]> => {
        if (keyword && keyword.trim() && keyword) {
            let url = this._baseUrl + 'v1/webAdmin/orgUnit/orgType/autoComplete';
            url += '?name=' + keyword;
            if (keyword) {
                return this.http.get(url)
                    .map((res) => {
                        return res;
                    }, (error) => {
                        console.log('catch orgUnitType Error' + error);
                        return Observable.of([]);
                    });
            } else {
                return Observable.of([]);
            }
        } else {
            return Observable.of([]);
        }
    }

    public autoCompleteListOrgTypeFormatter = (data: any): SafeHtml => {
        let html = `<span>${data.orgUnitTypeName}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    public changeOldValue() {
        let self = this;
        self.oldValue = null;
    }

    // when auto-complete value is selected this method fires and payload create
    public gotNewValue(e, type) {

        setTimeout(() => {
            this.changeOldValue();
        }, 1000);
        if (_.isObject(e)) {
            if (this.oldValue === type) {
                return;
            }
        } else if (e === '') {
            e = {id: null, name: null};
            this.oldValue = type;
        } else {
            return;
        }
        if (type === 'orgType') {
            this.orgData.orgType.id = e.id;
            this.orgData.level = e.level;
        }
        if (e) {
            if (type === 'primary') {
                this.orgData.houEmployeeId = e.id;
            }
            if (type === 'hrSpoc') {
                this.orgData.hrSpocId = e.id;
            }
            if (type === 'ccAdmin') {
                this.orgData.ccAdminId = e.id;
            }
            if (type === 'ccManager') {
                this.orgData.ccManagerId = e.id;
            }
            if (type === 'leaveAdministrator') {
                this.orgData.leaveAdministratorId = e.id;
            }
        }
    }

    // save organization
    public saveOrgData() {
        try {
            if (this.parentOrg != null) {
                this.orgData.parentId = this.parentOrg;
            }
            if (this.orgData.orgName == null || this.orgData.orgName === '') {
                this.translate.get('PLEASE_ENTER_ORGANIZATION_NAME_TO_CONTINUE')
                    .subscribe((res) => {
                        this._toaster.showError(res);
                    });
                return false;
            }
            if (this.orgData.orgUnitCode == null || this.orgData.orgUnitCode === '') {
                this.translate.get('PLEASE_ENTER_ORGANIZATION_CODE_TO_CONTINUE')
                    .subscribe((res) => {
                        this._toaster.showError(res);
                    });
                return false;
            }
            if (this.orgTypeModel == null) {
                this.translate.get('PLEASE_SELECT_ORG_TYPE').subscribe((res) => {
                    this._toaster.showError(res);
                });
                return false;
            }
            debugger;
            if (!this.orgTypeModel.id) {
                if (this.orgTypeModel.trim() === '') {
                    this.translate.get('PLEASE_SELECT_ORG_TYPE').subscribe((res) => {
                        this._toaster.showError(res);
                    });
                    return false;
                } else {
                    this.orgData.orgType = {};
                    this.orgData.orgType["id"] =  this.orgTypeModel.id;
                }
            } 

            this.disableButton = true;
            let url = this._baseUrl + 'v1/webAdmin/orgUnit';
            this.http.post(url, this.orgData).subscribe((result) => {
                if (result.success) {
                    this.addOrgEvent.emit({data: result.data, orgName: this.orgData.orgName});
                    this.cancelEvent.emit(true);
                    this.disableButton = false;
                } else {
                    for (let val of result.errorMessages) {
                        this.translate.get(val)
                            .subscribe((res) => {
                                this._toaster.showError(res);
                            });
                    }
                    this.disableButton = false;
                }
            });
        } catch (e) {
            console.log('saveOrg error caught', e);
        }
    }

    public closeInputs() {
        this.cancelEvent.emit(true);
    }
}



// WEBPACK FOOTER //
// ./src/app/tools/org/addOrganization.ts